import {
  patchState,
  signalStore,
  withMethods,
  withState,
} from '@ngrx/signals';
import { pipe, switchMap, tap } from 'rxjs';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { NotificationsService, UserNotification } from '@api';
import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

export interface NotificationsStateInterface {
  usersToBeNotified: UserNotification[];
  loadingNotifications: boolean;
  sendingNotifications: boolean;
}

export const NotificationsStore = signalStore(
  withState<NotificationsStateInterface>({
    usersToBeNotified: [],
    loadingNotifications: false,
    sendingNotifications: false,
  }),
  withMethods(
    (
      store,
      notificationsService = inject(NotificationsService),
      toastr = inject(ToastrService)
    ) => ({
      loadUsersToBeNotified: rxMethod<number>(
        pipe(
          switchMap((widgetId) => {
            patchState(store, { loadingNotifications: true });
            return notificationsService.getUsersToBeNotified(widgetId).pipe(
              tap((users) => {
                patchState(store, {
                  usersToBeNotified: users,
                  loadingNotifications: false,
                });
              })
            );
          })
        )
      ),
      notifyUsers(widgetId: number, elementType: 'LINK' | 'NEWS' | 'DOCUMENT') {
        patchState(store, { sendingNotifications: true });
        notificationsService.notifyUsers(widgetId, elementType).subscribe({
          next: () => {
            toastr.success(`Les notifications ont été envoyées`);
            patchState(store, { sendingNotifications: false });
          },
          error: () => {
            patchState(store, { sendingNotifications: false });
          },
        });
      },
    })
  )
);
